module.exports = __webpack_public_path__ + "img/column.388d3914.jpg";